import React from 'react'
import { css, cx } from '@emotion/css'
import { CsSortDescendingIcon, CsSortAscendingIcon } from '../icons'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { OrderDirection } from '.'
import { height, borderRadius } from './order-dropdown'

const buttonCss = css`
  border-radius: ${borderRadius}px 0 0 ${borderRadius}px;
  background-color: ${theme.color.neutral20};
  cursor: pointer;
  padding: 0 4px 0 6px;
  display: flex;
  align-items: center;
  height: ${height}px;
  margin-right: 2px;
`

interface Props {
  readonly onClick: () => void
  readonly direction: OrderDirection
}

export function OrderDirectionButton({ onClick, direction }: Props) {
  return (
    <div
      className={cx('order-direction-button', buttonCss)}
      onClick={onClick}
      data-testid="order-direction-selector-id"
    >
      {direction === 'ASC' ? (
        <CsSortAscendingIcon size="18" color="turquoise70" />
      ) : (
        <CsSortDescendingIcon size="18" color="turquoise70" />
      )}
    </div>
  )
}
